import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const Entertainment = () => {
  return (
    <div>
      <Navbar />
      Entertainment
      <Footer />

    </div>
  )
}

export default Entertainment
